"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var exceptions_1 = require("@ikea-aoa/exceptions");
var THOUSAND_SEPERATOR_REGEXP = /(\d+)(\d{3})/;
/**
 * Handles formatting of prices.
 */
var PriceFormatter = /** @class */ (function () {
    function PriceFormatter() {
    }
    /**
     * Formats a price.
     * Make sure that you add a dir="ltr" attribute to the HTML, so that '1 400' wont get reversed in morocco.
     *
     * @param amount Price amount.
     * @param priceSettings Price settings from LocalizationService.
     * @param fractions
     * @returns Formatted price with currency and spacing. The price formats are joinable by doing: priceFormat.map(price => price.value).join('').
     */
    PriceFormatter.format = function (amount, priceSettings) {
        if (typeof amount !== 'number' || isNaN(amount)) {
            throw new exceptions_1.Exception('Failed to format price. Invalid number.');
        }
        var numberOfDecimals = priceSettings.numberOfDecimals;
        if (isNaN(numberOfDecimals) || numberOfDecimals === null) {
            throw new exceptions_1.Exception('priceSettings.numberOfDecimals is not a number.');
        }
        var noValueDecimalsString = priceSettings.noValueDecimalsString === ' ' ? '' : priceSettings.noValueDecimalsString;
        var fixedAmount = amount.toFixed(numberOfDecimals).split('.'); // Since the number of trailing zeroes is set with the toFixed, the values cannot be integer
        var fraction = fixedAmount.length === 2 ? fixedAmount[1] : 0;
        // Thousand separator
        var integerString = fixedAmount[0];
        if (priceSettings.currencyCode === 'INR') {
            integerString = this.formatIndianThousandSeperator(integerString);
        }
        else if (priceSettings.thousandSeparatorEnabled && integerString.length > 3) {
            integerString = this.formatThousandSeperator(integerString, priceSettings.thousandSeparator);
        }
        // Decimals
        var decimalArray = [];
        if (priceSettings.replaceNoValueDecimals &&
            typeof noValueDecimalsString === 'string' &&
            Number(fraction) === 0) {
            decimalArray = [noValueDecimalsString];
        }
        else if (priceSettings.decimalSeparator && numberOfDecimals !== 0) {
            decimalArray = [priceSettings.decimalSeparator, fraction];
        }
        // List of parts in order
        var priceWithCurrency = [
            {
                type: 'integerPart',
                value: integerString
            }
        ];
        if (decimalArray.length > 0) {
            priceWithCurrency.push({
                type: 'decimalPart',
                value: decimalArray.join('')
            });
        }
        if (priceSettings.currencyPosition === 'before') {
            if (priceSettings.symbolSpacing) {
                priceWithCurrency.unshift({
                    type: 'spacing',
                    value: ' '
                });
            }
            priceWithCurrency.unshift({
                type: 'currency',
                value: priceSettings.currencySymbol
            });
        }
        else {
            if (priceSettings.symbolSpacing) {
                priceWithCurrency.push({
                    type: 'spacing',
                    value: ' '
                });
            }
            priceWithCurrency.push({
                type: 'currency',
                value: priceSettings.currencySymbol
            });
        }
        return priceWithCurrency;
    };
    /**
     * Returns Indian price with thousand separator.
     *
     * @param integerString Price integer part (no decimals).
     * @returns Indian price with thousand separator.
     */
    PriceFormatter.formatIndianThousandSeperator = function (integerString) {
        var result = [];
        var thousand = '';
        if (integerString.length > 3) {
            thousand = ',' + integerString.substr(integerString.length - 3);
            integerString = integerString.substr(0, integerString.length - 3);
            while (integerString.length > 2) {
                result.unshift(integerString.substr(integerString.length - 2));
                integerString = integerString.substr(0, integerString.length - 2);
            }
        }
        if (integerString.length > 0) {
            result.unshift(integerString);
        }
        return result.join(',') + thousand;
    };
    /**
     * Returns price with thousand separator.
     *
     * @param integerString Price integer part (no decimals).
     * @param thousandSeparator Thousand separator.
     * @returns Price with thousand separator.
     */
    PriceFormatter.formatThousandSeperator = function (integerString, thousandSeparator) {
        var separator = thousandSeparator || ' ';
        while (THOUSAND_SEPERATOR_REGEXP.test(integerString)) {
            integerString = integerString.replace(THOUSAND_SEPERATOR_REGEXP, '$1' + separator + '$2');
        }
        return integerString;
    };
    return PriceFormatter;
}());
exports.default = PriceFormatter;
//# sourceMappingURL=PriceFormatter.js.map